export default __webpack_public_path__ + "static/media/Slide3.e278a146.jpg";